import { useState, useEffect, useMemo } from "react";

// Client-side pagination for list/table pages. Pass the (already filtered) array.
export function usePagination(items, defaultSize = 25) {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(defaultSize);
  const total = items?.length || 0;

  // Reset to the first page whenever the data set or page size changes.
  useEffect(() => { setPage(0); }, [total, pageSize]);

  const size = pageSize === "all" ? Math.max(total, 1) : pageSize;
  const pageCount = Math.max(1, Math.ceil(total / size));
  const safePage = Math.min(page, pageCount - 1);
  const startIdx = safePage * size;

  const pageItems = useMemo(
    () => (pageSize === "all" ? (items || []) : (items || []).slice(startIdx, startIdx + size)),
    [items, pageSize, startIdx, size]
  );

  return { page: safePage, setPage, pageSize, setPageSize, total, size, pageCount, startIdx, pageItems };
}
